function handleAddressVerificationResponse(response) {
    if (typeof(response.Address) === undefined) {
        // pass on because this response is unexpected and don't want to lock out user
        return {'can_submit': true};
    }
    // DPVConfirmation != Y when address isn't determined to be deliverable. In that case Address.ReturnText is the error message
    if (response.Address.Error || response.Address.DPVConfirmation !== 'Y') {
        var $errorMessage = '';
        // include the error description if it isn't the vague default error.
        if (response.Address.Error && response.Address.Error.Description.indexOf('Address Not Found.') < 0) {
            $errorMessage = response.Address.Error.Description;
        }
        if (response.Address.ReturnText) {
            $errorMessage = response.Address.ReturnText;
        }
        return {'can_submit': false, 'error_message': $errorMessage};
    }
    // else continue and let submit
    return {'can_submit': true};
}

export default handleAddressVerificationResponse;